import api from 'containers/api'
import { selectToken } from 'containers/authentication/authenticationSlice'
import useDataLoader from 'containers/dataLoader'
import { useSelector } from 'react-redux'
import { IOrganization } from 'types'

const useShareDataset = (organization: IOrganization) => {
  const token = useSelector(selectToken)
  const shareDataset = (email: string) => {
    return api.shareDataset(email, token, organization.id)
  }

  return useDataLoader(shareDataset)
}

export default useShareDataset
